(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var App = {
  debug: false,
  preloadedImages: [],
  cookieName: "novum-dental",
  cookiesCopy: cookiesCopy,
  inputsToValidate: ["name", "phone", "email", "day",
  // "val-hour",
  "check-1"],
  errorsArray: ["name", "phone", "email", "day",
  // "val-hour",
  "check-1"],
  cookies: {
    createCookie: function createCookie(name, value, days) {
      var _this = App;
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
      document.cookie = name + "=" + value + expires + "; path=/";
      _this.debug ? console.log("creating cookie: ", name) : null;
    },
    removeCookie: function removeCookie(name) {
      var _this = App;
      _this.cookies.createCookie(name, "", 0);
    },
    readCookie: function readCookie(name) {
      var _this = App;
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    checkCookies: function checkCookies() {
      var _this = App;
      if (_this.cookies.readCookie(_this.cookieName) != 1) {
        _this.debug ? console.log("cookie %s is not created yet", _this.cookieName) : null;
        _this.cookies.notification("show");
      } else {
        _this.debug ? console.log("cookie %s already exists", _this.cookieName) : null;
      }
      $(".close-notification").on("click", function () {
        _this.cookies.createCookie(_this.cookieName, 1, 365);
        _this.cookies.notification("hide");
      });
    },
    notification: function notification(state) {
      var _this = App;
      switch (state) {
        case "show":
          $("body").append('<div class="cookies-notification"><p>' + _this.cookiesCopy + '</p><a><img class="ml-2 close-notification" src="' + baseUrl + 'assets/images/btn-close.png" alt="" ></a></div>');
          break;
        case "hide":
          $(".cookies-notification").fadeOut(300, function () {
            $(this).remove();
          });
          break;
      }
    }
  },
  windowWidth: function windowWidth() {
    return window.innerWidth;
  },
  readOffset: function readOffset() {
    var _this = this;
    return _this.windowWidth() >= 1280 ? 80 : 115;
  },
  inViewport: function inViewport(el) {
    var r, html;
    if (!el || 1 !== el.nodeType) {
      return false;
    }
    html = document.documentElement;
    r = el.getBoundingClientRect();

    return !!r && r.bottom >= 0 && r.right >= 0 && r.top <= html.clientHeight && r.left <= html.clientWidth;
  },
  getBrowserName: function getBrowserName() {
    var name = "Unknown";
    if (navigator.userAgent.indexOf("MSIE") != -1) {
      name = "MSIE";
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      name = "Firefox";
    } else if (navigator.userAgent.indexOf("Opera") != -1) {
      name = "Opera";
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      name = "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      name = "Safari";
    }
    return name;
  },
  iOS: function iOS() {
    return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    navigator.userAgent.includes("Mac") && "ontouchend" in document;
  },
  mobileAndTabletCheck: function mobileAndTabletCheck() {
    // https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
    var check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  },
  readHash: function readHash() {
    var _this = this;
    if (window.location.hash) {
      setTimeout(function () {
        _this.scrollTo(window.location.hash);
      }, 350);
    }
  },
  scrollTo: function scrollTo(elemenId) {
    var _this = this,
        offset = _this.readOffset();

    elemenId = elemenId.substr(1);
    $("html, body").animate({ scrollTop: $("#section-" + elemenId).offset().top - offset }, 450);
    window.location.hash = elemenId;
  },
  validateEmail: function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },
  validateName: function validateName(name) {
    var nameArr = name.trim().split(" ");
    return nameArr.length >= 2 ? false : true;
  },
  validatePhone: function validatePhone(phone) {
    var re = /^[0-9\+-]{9,12}$/;
    return re.test(phone);
  },
  validateForm: function validateForm() {
    var _this = this;

    _this.inputsToValidate.forEach(function (element) {
      _this.debug ? console.log("element " + element) : null;
      if ($("#" + element).length) {
        // console.log(element);
        if ($("#" + element).val().length == 0 && $("#" + element).attr("type") == "text") {
          $("#label-" + element).addClass("error");
          _this.errorsArray.push(element);
          _this.styleSubmitButton();
        } else {
          $("#label-" + element).removeClass("error");
          _this.removeError(element);
          // if value is not empty validate it

          // validate name & surname
          if ($("#" + element).attr("id") == "name" || $("#" + element).attr("id") == "surname") {
            if ($("#" + element).val().length <= 2) {
              $("#label-" + element).addClass("error");
              return;
            }
          }

          // validate phone number
          if ($("#" + element).attr("id") == "phone") {
            if ($("#" + element).val() == "") {
              $("#label-" + element).addClass("error");
              return;
            }
            if (_this.validatePhone($("#" + element).val())) {
              $("#label-" + element).removeClass("error");
              $(".error--phone").hide();
              //console.log("remove phone error");
              _this.removeError(element);
            } else {
              //console.log("add phone error");
              $("#label-" + element).addClass("error");
              $(".error--phone").show();
              _this.errorsArray.push(element);
            }
          }

          // validate email
          if ($("#" + element).attr("id") == "email") {
            if ($("#" + element).val() == "") {
              $("#label-" + element).addClass("error");
              return;
            }
            if (_this.validateEmail($("#" + element).val())) {
              $("#label-" + element).removeClass("error");
              $(".error--email").hide();
              //console.log("remove email error");
              _this.removeError(element);
            } else {
              //console.log("add email error");
              $("#label-" + element).addClass("error");
              $(".error--email").show();
              _this.errorsArray.push(element);
            }
          }

          // validate checkboxes
          if ($("#" + element).attr("type") == "checkbox") {
            if ($("#" + element).prop("checked") == false) {
              // console.log("add checkbox error");
              $("#label-" + element).addClass("error");
              // $(".error--" + element).addClass("d-block");
              _this.errorsArray.push(element);
            } else {
              // console.log("remove checkbox error");
              $("#label-" + element).prev().removeClass("error");
              // $(".error--" + element).removeClass("d-block");
              _this.removeError(element);
            }
          }
        }
      }
    });
    if (_this.errorsArray) {
      if (_this.windowWidth() < 1280) {
        _this.scrollTo("#contact");
      }
    }
  },
  removeError: function removeError(element) {
    var _this = this;

    if ($.inArray(element, _this.errorsArray) > -1) {
      // console.log(">>removeError: " + element);

      var index = _this.errorsArray.indexOf(element);
      if (index !== -1) {
        _this.errorsArray.splice(index, 1);
      }
      return _this.errorsArray;
    }
  },
  styleSubmitButton: function styleSubmitButton() {
    var _this = this;

    if (_this.errorsArray.length == 0) {
      $("#btn-submit").removeClass("opacity");
    } else {
      $("#btn-submit").addClass("opactiy");
    }
  },
  fakeSelect: function fakeSelect() {
    var _this = this;

    $(".fake-select-trigger").on("click", function () {
      if ($(this).next().next(".fake-select-option").hasClass("active")) {
        $(this).next().next(".fake-select-option").removeClass("active");
      } else {
        $(".fake-select-option").removeClass("active");
        $(this).next().next(".fake-select-option").addClass("active");
      }
    });
    $("body").on("click", ".fake-select-option li", function () {
      var selectedItem = $(this).text();
      // console.log(selectedItem);
      $(this).parent().removeClass("active");
      $(this).parent().prev().text(selectedItem);
      $(this).parent().next().val(selectedItem);
    });
  },
  hideMenu: function hideMenu() {
    $("#navbar-example").removeClass("open");
    $(".navbar-collapse").removeClass("show");
  },
  promoModal: function promoModal() {
    var _this = this;

    // console.log(_this.cookies.readCookie("promoModal"))

    if (_this.cookies.readCookie("promoModal") === null) {
      $("#promoModal").modal("show");
    }
  },

  events: function events() {
    var _this = this;

    // mobile menu events
    $(".navbar-toggler").on("click", function () {
      $("#navbar-example").toggleClass("open");
    });
    $(".navbar-nav .nav, .navlink").on("click", function (event) {
      event.preventDefault();

      var selectedId = $(this).attr("href");
      _this.debug ? console.log(selectedId) : null;

      _this.hideMenu();
      _this.scrollTo(selectedId);

      if ($(this).hasClass("src-modal")) {
        $("#promoModal").modal("hide");
        _this.cookies.createCookie("promoModal", 1, 5);
      }
    });

    // form events
    $(".custom-control-label").on("click", function () {
      var element = $(this).attr("for");

      $(this).removeClass("error");
      // $(".error--" + element).removeClass("d-lg-block");

      _this.removeError(element);
      _this.styleSubmitButton();
    });
    $(".form input, .form textarea").blur(function () {
      var inputValue = $(this).val();

      _this.debug ? console.log($(this).attr("id") + ": " + inputValue) : null;

      if (inputValue != "" && $(this).attr("id") == "email") {
        if (!_this.validateEmail(inputValue)) {
          _this.errorsArray.push($(this).attr("id"));
          $("#label-email").addClass("error");
          $(".error--email").show();
          return;
        } else {
          $("#label-email").removeClass("error");
          $(".error--email").hide();
        }
      }

      if (inputValue != "" && $(this).attr("id") == "phone") {
        if (!_this.validatePhone(inputValue)) {
          _this.errorsArray.push($(this).attr("id"));
          $("#label-phone").addClass("error");
          $(".error--phone").show();
          return;
        } else {
          $("#label-phone").removeClass("error");
          $(".error--phone").hide();
        }
      }

      if (inputValue != "" && ($(this).attr("id") == "name" || $(this).attr("id") == "day" || $(this).attr("id") == "hour")) {
        if (inputValue == "") {
          $(this).parents(".form-group").removeClass("focused");
        } else {
          if (inputValue.length >= 3) {
            $(this).prev().removeClass("error");

            _this.removeError($(this).attr("id"));
          }
          _this.styleSubmitButton();
        }
      }
    });

    _this.fakeSelect();

    $("#btn-submit").on("click", function (event) {
      event.preventDefault();

      _this.debug ? console.log("btn-submit") : null;
      _this.errorsArray = [];
      _this.validateForm();

      gtag("event", "click", {
        event_category: "section contact",
        event_label: "button submit"
      });

      if (_this.errorsArray.length == 0) {
        gtag("event", "action", {
          event_category: "contact form",
          event_label: "form submited"
        });

        // set chaptcha
        grecaptcha.ready(function () {
          _this.debug ? console.log("captcha ready") : null;
          // set chaptcha
          grecaptcha.execute(captchaPublic, {
            action: "submit"
          }).then(function (token) {
            // Add your logic to submit to your backend server here.
            _this.debug ? console.log("token is ready", token) : null;
            $("#captcha").val(token);

            var url = $("form").attr("action"),
                data = $("#section-form").serialize();
            _this.debug ? console.log(data) : null;

            $.post(url, data, function (data) {
              _this.debug ? console.log(data) : null;
            }).done(function (data) {
              // TODO sprawdzanie zwrotki, response obsługa captcha-error
              // console.log(data);
              $(".form").addClass("d-none");
              $(".confirmation").removeClass("d-none");
              _this.scrollTo("#section-contact");
            }).fail(function (data) {
              // alert("error");
              console.log(data);
              gtag("event", "action", {
                event_category: "contact form",
                event_label: "submit failed"
              });
            }).always(function () {
              // alert("finished");
            });
          });
        });
        return false;
      }
    });
  },
  generateCustomSelect: function generateCustomSelect(dayOfWeek) {
    // console.debug('generateCustomSelect', dayOfWeek);
    var _this = this,
        dynamicSelect = $("#hour-select"),
        openHour = 8,
        closeHour = dayOfWeek === 5 ? 13 : 20;

    dynamicSelect.empty();
    $("#hour-selected").empty();
    $("#val-hour").val("");

    for (var index = openHour; index < closeHour; index++) {
      dynamicSelect.append('<li class="li-' + index + '">' + index + ":00</li>");
    }
  },
  init: function init() {
    var _this = this;

    console.log("init");
    _this.readHash();
    _this.events();
    _this.cookies.checkCookies();

    $("#day").datepicker({
      minDate: 1,
      beforeShowDay: function beforeShowDay(date) {
        var day = date.getDay();
        return [day != 0, ""];
      },
      onSelect: function onSelect(event, ui) {
        var date = $(this).datepicker("getDate");
        var dayOfWeek = date.getUTCDay();

        _this.generateCustomSelect(dayOfWeek);
      }
    });

    $(".carousel").carousel({
      interval: false
    });

    // import PhotoSwipeLightbox from "https://unpkg.com/photoswipe/dist/photoswipe-lightbox.esm.js";

    var lightboxMobile = new PhotoSwipeLightbox({
      gallery: "#nd-gallery-mobile",
      children: "a",
      // dynamic import is not supported in UMD version
      pswpModule: PhotoSwipe
    });
    lightboxMobile.init();

    var lightboxDesktop = new PhotoSwipeLightbox({
      gallery: "#nd-gallery-desktop",
      children: "a",
      // dynamic import is not supported in UMD version
      pswpModule: PhotoSwipe
    });
    lightboxDesktop.init();
  }
};

window.App = App;

$(function () {
  App.init();
});

$(window).on("resize", function () {
  // console.log(window.innerHeight);
  App.hideMenu();
}).resize();

$(window).on("load", function () {
  // $(".loader").fadeOut();
});

$(window).on("scroll", function () {});

// Listen for orientation changes
window.addEventListener("orientationchange", function (event) {}, false);

},{}]},{},[1]);
